export function getCurrencySymbol(currency: string): string {
  switch (currency) {
    case 'kzt':
      return '₸';
    case 'usd':
      return '$';
    case 'rub':
    default:
      return '₽';
  }
}
